/* Epycure — « Quels produits associer ? ».
 * Le verdict additionne les vitamines et minéraux des produits choisis (matrice de compatibilité,
 * snippet epy-association-matrice) et compare chaque total à son plafond journalier.
 * Zinc : compatible jusqu'au palier sans risque, avertissement jusqu'au maximum, incompatible au-delà. */
(function (racine) {
  'use strict';

  var EPS = 1e-9;

  function verdict(poignees, donnees) {
    var totaux = {};
    poignees.forEach(function (p) {
      var produit = donnees.produits[p];
      if (!produit) return;
      Object.keys(produit.nutriments).forEach(function (n) {
        totaux[n] = (totaux[n] || 0) + produit.nutriments[n];
      });
    });
    var depassements = [];
    Object.keys(totaux).forEach(function (n) {
      if (n === 'Zinc') return;
      var plafond = donnees.plafonds[n];
      if (plafond !== undefined && totaux[n] > plafond + EPS) {
        depassements.push({ nutriment: n, total: totaux[n], plafond: plafond, unite: donnees.unites[n] });
      }
    });
    var zinc = totaux.Zinc || 0;
    var zincAttention = false;
    if (zinc > donnees.zinc.maximum + EPS) {
      depassements.push({ nutriment: 'Zinc', total: zinc, plafond: donnees.zinc.maximum, unite: donnees.unites.Zinc });
    } else if (zinc > donnees.zinc.sans_risque + EPS) {
      zincAttention = true;
    }
    var statut = depassements.length ? 'incompatible' : zincAttention ? 'attention' : 'compatible';
    return { statut: statut, depassements: depassements, zinc: zinc };
  }

  function nombre(v) {
    return (Math.round(v * 100) / 100).toLocaleString('fr-FR');
  }

  function normaliser(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function monter(el) {
    var donnees = JSON.parse(el.querySelector('[data-asso-matrice]').textContent);
    var max = Number(el.dataset.max) || 3;
    var lignes = Array.prototype.slice.call(el.querySelectorAll('[data-asso-produit]'));
    var choix = [];
    var etat = 'choix';

    var parPoignee = {};
    lignes.forEach(function (l) { parPoignee[l.dataset.handle] = l; });

    // Classement de A à Z, « Électrolytes » rangé à E, un titre de lettre par groupe.
    var liste = el.querySelector('[data-asso-liste]');
    var aucun = el.querySelector('[data-asso-aucun]');
    lignes.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title, 'fr', { sensitivity: 'base' }); });
    var groupe = null;
    lignes.forEach(function (l) {
      var lettre = normaliser(l.dataset.title).charAt(0).toUpperCase();
      if (!groupe || groupe.dataset.assoLettre !== lettre) {
        groupe = document.createElement('div');
        groupe.dataset.assoLettre = lettre;
        var h = document.createElement('h2');
        h.className = 'epy-asso__lettre';
        h.textContent = lettre;
        groupe.appendChild(h);
        liste.insertBefore(groupe, aucun);
      }
      groupe.appendChild(l);
    });

    var q = function (s) { return el.querySelector(s); };
    var puces = el.querySelectorAll('[data-asso-puces]');
    var boutons = el.querySelectorAll('[data-asso-verifier]');
    var recherche = q('[data-asso-recherche]');
    var vide = q('[data-asso-aucun]');
    var etapes = el.querySelectorAll('[data-asso-etape]');

    function titre(p) { return parPoignee[p].dataset.title; }

    function rafraichir() {
      lignes.forEach(function (l) {
        var pris = choix.indexOf(l.dataset.handle) !== -1;
        l.classList.toggle('is-selected', pris);
        var b = l.querySelector('[data-asso-basculer]');
        b.setAttribute('aria-pressed', pris ? 'true' : 'false');
        b.setAttribute('aria-label', (pris ? 'Retirer ' : 'Ajouter ') + l.dataset.title);
        b.disabled = !pris && choix.length >= max;
      });
      Array.prototype.forEach.call(puces, function (zone) {
        zone.innerHTML = '';
        choix.forEach(function (p) {
          var puce = document.createElement('button');
          puce.type = 'button';
          puce.className = 'epy-asso__puce';
          puce.innerHTML = '<span></span><svg aria-hidden="true" viewBox="0 0 12 12" width="10" height="10"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.6"/></svg>';
          puce.firstChild.textContent = titre(p);
          puce.setAttribute('aria-label', 'Retirer ' + titre(p));
          puce.addEventListener('click', function () { basculer(p); });
          zone.appendChild(puce);
        });
        zone.hidden = choix.length === 0;
      });
      Array.prototype.forEach.call(boutons, function (b) {
        b.disabled = choix.length < 2;
        var n = b.querySelector('[data-asso-compte]');
        if (n) n.textContent = choix.length ? ' (' + choix.length + ')' : '';
      });
      var aide = el.querySelectorAll('[data-asso-aide]');
      Array.prototype.forEach.call(aide, function (a) {
        a.textContent = choix.length >= max
          ? 'Vous avez choisi ' + max + ' produits, le maximum conseillé.'
          : choix.length === 1 ? 'Choisissez au moins un autre produit.' : '';
      });
    }

    function basculer(p) {
      var i = choix.indexOf(p);
      if (i !== -1) choix.splice(i, 1);
      else if (choix.length < max) choix.push(p);
      rafraichir();
    }

    function filtrer() {
      var t = normaliser(recherche.value.trim());
      var visibles = 0;
      lignes.forEach(function (l) {
        var ok = !t || normaliser(l.dataset.title + ' ' + l.dataset.subtitle).indexOf(t) !== -1;
        l.hidden = !ok;
        if (ok) visibles++;
      });
      el.querySelectorAll('[data-asso-lettre]').forEach(function (g) {
        g.hidden = !g.querySelector('[data-asso-produit]:not([hidden])');
      });
      vide.hidden = visibles > 0;
    }

    function passer(nouvel) {
      etat = nouvel;
      el.dataset.etat = etat;
      Array.prototype.forEach.call(etapes, function (e) {
        var n = Number(e.dataset.assoEtape);
        e.classList.toggle('is-active', (etat === 'choix' && n === 1) || (etat === 'resultat' && n === 3));
        e.classList.toggle('is-done', etat === 'resultat' && n < 3);
      });
    }

    function afficherResultat() {
      var v = verdict(choix, donnees);
      var bloc = q('[data-asso-resultat]');
      var gabarit = q('template[data-asso-verdict="' + v.statut + '"]');
      var verdictEl = q('[data-asso-verdict-zone]');
      verdictEl.innerHTML = '';
      verdictEl.appendChild(gabarit.content.cloneNode(true));
      var liste = verdictEl.querySelector('[data-asso-depassements]');
      if (liste) {
        v.depassements.forEach(function (d) {
          var li = document.createElement('li');
          li.textContent = d.nutriment + ' : ' + nombre(d.total) + ' ' + d.unite + ' par jour, pour un maximum de ' + nombre(d.plafond) + ' ' + d.unite + '.';
          liste.appendChild(li);
        });
      }
      var zincEl = verdictEl.querySelector('[data-asso-zinc]');
      if (zincEl) zincEl.textContent = nombre(v.zinc) + ' mg';

      var produits = q('[data-asso-resultat-produits]');
      produits.innerHTML = '';
      choix.forEach(function (p) {
        var src = parPoignee[p].querySelector('template[data-asso-carte]');
        produits.appendChild(src.content.cloneNode(true));
      });
      var tout = q('[data-asso-tout-ajouter]');
      var ajoutables = choix.filter(function (p) { return parPoignee[p].dataset.variant && parPoignee[p].dataset.available === 'true'; });
      tout.hidden = v.statut === 'incompatible' || ajoutables.length < 2;
      tout.dataset.variants = ajoutables.map(function (p) { return parPoignee[p].dataset.variant; }).join(',');
      passer('resultat');
      bloc.focus({ preventScroll: true });
      var haut = el.getBoundingClientRect().top + window.scrollY - 120;
      if (window.scrollY > haut) window.scrollTo({ top: haut, behavior: 'smooth' });
    }

    function ajouter(ids, bouton) {
      var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
      var texte = bouton.textContent;
      bouton.disabled = true;
      var fini = function () { bouton.disabled = false; };
      var requete = window.EpycureCart && window.EpycureCart.add
        ? window.EpycureCart.add({ items: items }, { source: 'association' })
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { if (!r.ok) throw new Error(); window.location.href = '/cart'; });
      Promise.resolve(requete).then(fini, function () {
        fini();
        bouton.textContent = 'Ajout impossible, réessayez';
        setTimeout(function () { bouton.textContent = texte; }, 3000);
      });
    }

    lignes.forEach(function (l) {
      l.querySelector('[data-asso-basculer]').addEventListener('click', function () { basculer(l.dataset.handle); });
    });
    recherche.addEventListener('input', filtrer);
    Array.prototype.forEach.call(boutons, function (b) { b.addEventListener('click', afficherResultat); });
    el.addEventListener('click', function (e) {
      var a = e.target.closest('[data-asso-ajouter]');
      if (a) ajouter([a.dataset.assoAjouter], a);
      var t = e.target.closest('[data-asso-tout-ajouter]');
      if (t) ajouter(t.dataset.variants.split(','), t);
      if (e.target.closest('[data-asso-recommencer]')) {
        choix = [];
        recherche.value = '';
        filtrer();
        rafraichir();
        passer('choix');
      }
      if (e.target.closest('[data-asso-modifier]')) passer('choix');
    });

    rafraichir();
    passer('choix');
  }

  racine.EpycureAssociation = { verdict: verdict };
  if (typeof document !== 'undefined') {
    var lancer = function () { document.querySelectorAll('[data-epy-association]').forEach(monter); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer);
    else lancer();
  }
  if (typeof module !== 'undefined') module.exports = { verdict: verdict };
})(typeof window !== 'undefined' ? window : globalThis);
